import { APP_VERSION } from "../../constants/appVersion";
import {
  buildTechnicalDiagnostics,
  extractClientErrorMessage,
} from "./sanitizeErrorForReport";

export { extractClientErrorMessage };

function formatContextValue(value) {
  if (value == null) return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

/** Payload for POST /api/support/bug-report (member consented; description auto-generated). */
export function buildSupportErrorReport({
  page,
  action,
  userMessage,
  error,
  context = {},
  category = "broken",
  includeConsole = true,
}) {
  const serverDetail = extractClientErrorMessage(error);
  const status = error?.response?.status;
  const lines = [
    `Automatic error report from NewEra.`,
    "",
    `Page: ${page || "(unknown)"}`,
    `Action: ${action || "(unknown)"}`,
    `User-facing message: ${userMessage || "(none)"}`,
  ];
  if (serverDetail) lines.push(`Server detail: ${serverDetail}`);
  if (status) lines.push(`HTTP status: ${status}`);

  const contextEntries = Object.entries(context).filter(
    ([, v]) => v !== undefined && v !== null && v !== ""
  );
  if (contextEntries.length > 0) {
    lines.push("", "Context:");
    for (const [key, value] of contextEntries) {
      lines.push(`- ${key}: ${formatContextValue(value)}`);
    }
  }

  lines.push("", `Time (UTC): ${new Date().toISOString()}`);

  let description = lines.join("\n");
  if (description.length < 10) {
    description = `Error on ${page || "app"}: ${userMessage || serverDetail || "unknown error"}.`;
  }
  if (description.length > 4000) {
    description = `${description.slice(0, 3997)}...`;
  }

  const urlPath =
    typeof window !== "undefined"
      ? window.location.pathname + window.location.search
      : "";

  const technical = buildTechnicalDiagnostics(error, { includeConsole });

  return {
    category,
    description,
    steps: `The member agreed to send this report after an error on ${page || "the app"}.`,
    page: page || "",
    urlPath,
    includeDiagnostics: true,
    appVersion: APP_VERSION,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    companyWebsite: "",
    clientStack: technical.clientStack,
    apiResponseSnippet: technical.apiResponseSnippet,
    recentConsole: technical.recentConsole,
  };
}

/** Manual bug report — optional stack / console when diagnostics enabled. */
export function buildManualReportTechnicalFields(error, includeDiagnostics) {
  if (!includeDiagnostics) {
    return {
      clientStack: "",
      apiResponseSnippet: "",
      recentConsole: "",
    };
  }
  return buildTechnicalDiagnostics(error, { includeConsole: true });
}
